"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForTickCount = exports.promisedWait = void 0;
function promisedWait(ms) {
    return new Promise((resolve => {
        setTimeout(resolve, ms);
    }));
}
exports.promisedWait = promisedWait;
/**
 * Awaits setTimeout(0) for the specified number of counts provided.
 * Adding as a crude form of control flow backpressure for the situation of a race for services to respond about their availability
 *  for more work. A server under heavy cpu load will take more time to reply and lose the race, while a few extra ticks
 *  should be painless to handle for the low-load server.
 * @param n
 */
function waitForTickCount(n) {
    return __awaiter(this, void 0, void 0, function* () {
        for (let i = 0; i < n; i++) {
            yield promisedWait(0);
        }
    });
}
exports.waitForTickCount = waitForTickCount;
//# sourceMappingURL=promised-wait.js.map